import React from 'react';
import {
  Box,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  useTheme,
  Collapse,
  ListItemIcon,
} from '@mui/material';
import { useHistory, useLocation } from 'react-router-dom';
import PaletteIcon from '@mui/icons-material/Palette';
import TextFieldsIcon from '@mui/icons-material/TextFields';
import WidgetsIcon from '@mui/icons-material/Widgets';
import LabelIcon from '@mui/icons-material/Label';

const drawerWidth = 240;

const ThemeShowcaseLayout = ({ children }: { children: React.ReactNode }) => {
  const theme = useTheme();
  const history = useHistory();
  const location = useLocation();
  const [componentsOpen, setComponentsOpen] = React.useState(true);

  const handleComponentsClick = () => {
    setComponentsOpen(!componentsOpen);
  };

  const menuItems = [
    {
      label: 'Colors',
      path: '/theme-showcase/colors',
      icon: <PaletteIcon />,
    },
    {
      label: 'Typography',
      path: '/theme-showcase/typography',
      icon: <TextFieldsIcon />,
    },
    {
      label: 'Chip',
      path: '/theme-showcase/components/chip',
      icon: <LabelIcon />,
    },
    {
      label: 'Toggle Button',
      path: '/theme-showcase/components/toggle-button',
      icon: <WidgetsIcon />,
    },
    {
      label: 'Tooltip',
      path: '/theme-showcase/components/tooltip',
      icon: <WidgetsIcon />,
    },
    {
      label: 'Text Editor',
      path: '/theme-showcase/components/text-editor',
      icon: <WidgetsIcon />,
    },
  ];

  return (
    <Box sx={{ display: 'flex', height: '100vh' }}>
      <Drawer
        variant="permanent"
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
            marginTop: '56px', // Height of the header
            backgroundColor: theme.palette.background.paper,
          },
        }}>
        <List>
          {menuItems.map((item) => (
            <ListItem key={item.path} disablePadding>
              <ListItemButton
                selected={location.pathname === item.path}
                onClick={() => history.push(item.path)}
                sx={{
                  '&.Mui-selected': {
                    backgroundColor: theme.palette.primary.main,
                    color: theme.palette.primary.contrastText,
                    '&:hover': {
                      backgroundColor: theme.palette.primary.dark,
                    },
                  },
                }}>
                <ListItemIcon sx={{ color: 'inherit' }}>{item.icon}</ListItemIcon>
                <ListItemText primary={item.label} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Drawer>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          marginTop: '56px', // Height of the header
          backgroundColor: theme.palette.background.default,
          overflow: 'auto',
        }}>
        {children}
      </Box>
    </Box>
  );
};

export default ThemeShowcaseLayout;
